import {createContext} from "react";

export const BadgeContext = createContext({
    hasLabel: false,
    rounded: false,
    color: 'default',
    size: 'default',
    icon: false,
    indicator: false,
    indicatorIcon: null,
    backgroundColor: 'default',
    indicatorColor: 'default',
    iconColor: 'default',
    labelColor: 'default',
    labelSize: 12,
    isBold: true,
    border: false,
    borderColor: null,
    onClick: null,
    fullWidth: false,
    centerContent: false
})
